/** @type Map<string, AbortController>*/
const fetchAbortMap = new Map()

export async function singletonFetch (id, input, init = undefined) {
  if (fetchAbortMap.has(id)) {
    fetchAbortMap.get(id).abort()
  }
  fetchAbortMap.set(id, new AbortController())
  let signal = fetchAbortMap.get(id).signal
  return await fetch(input, { ...init, signal })
}